import { MembersModel } from '../../../models/members.model';

// tslint:disable-next-line: no-namespace
export namespace MembersAction {
    export class Add {
        static readonly type = '[Members] Add';
        constructor(public payload: MembersModel) {}
    }

    export class GetAll {
        static readonly type = '[Members] GetAll';
        constructor() {}
    }

    export class GetRoles {
        static readonly type = '[Members] GetRoles';
        constructor(public orgId: string) {}
    }

    export class ResetPin {
        static readonly type = '[Members] ResetPin';
        constructor(public memberId: string) {}
    }

    export class SelectedMember {
        static readonly type = '[Members] SelectedMember';
        constructor(public member: MembersModel) {}
    }

    export class ClearMemberForm {
        static readonly type = '[Members] ClearMemberForm';
        constructor() {}
    }

    export class AddCustomer {
        static readonly type = '[Members] AddCustomer';
        constructor() {}
    }

    export class GetCustomers {
        static readonly type = '[Members] GetCustomers';
        constructor() {}
    }

    export class ResetCustomer {
        static readonly type = '[Members] Reset Customer';
        constructor() {}
    }

    export class DeleteCustomer {
        static readonly type = '[Members] DeleteCustomer';
        constructor(public payload: any) {}
    }

    export class DeleteStaff {
        static readonly type = '[Members] DeleteStaff';
        constructor(public payload: any) {}
    }

    export class AddDeliverer {
        static readonly type = '[Members] AddDeliverer';
        constructor(public payload: any) {}
    }

    export class GetDeliverers {
        static readonly type = '[Members] GetDeliverers';
        constructor() {}
    }

    export class DeleteDeliverer {
        static readonly type = '[Members] DeleteDeliverer';
        constructor(public payload: any) {}
    }

    export class GetCountries {
        static readonly type = '[Members] GetCountries';
        constructor() {}
    }

    export class GetStates {
        static readonly type = '[Member] GetStates';
        constructor(public payload: any) {}
    }

    export class GetCities {
        static readonly type = '[Member] GetCities';
        constructor(public payload: any) {}
    }

    export class AddDiscount {
        static readonly type = '[Member] AddDiscount';
        constructor() {}
    }

    export class GetDiscount {
        static readonly type = '[Member] GetDiscount';
        constructor() {}
    }

    export class DeleteDiscount {
        static readonly type = '[Member] DeleteDiscount';
        constructor(public payload: any) {}
    }

    export class GetServiceAreas {
        static readonly type = '[Member] GetServiceAreas';
        constructor() {}
    }

    export class CurrentUser {
        static readonly type = '[Member] CurrentUser';
        constructor() {}
    }
}
